import { ColorStop } from 'features/mapping/mapping.types';
import { FocusedSensorType } from 'state/useWeatherStationState';

export const METERS_PER_SEC_TO_MPH_FACTOR = 2.237;

export const OFFLINE_STATION_COLOR = '#d9d9d9';

const STOP_COLORS = {
  white: '#FFFFFF',
  purpleRed: '#CC78B3',
  purple: '#B28AF3',
  bluePurple: '#8C90F0',
  blue: '#5DB8E8',
  greenBlue: '#5BC7A4',
  green: '#7AD56C',
  yellowGreen: '#BFD363',
  yellow: '#EADA53',
  orangeYellow: '#F3C842',
  orange: '#F8A63F',
  redOrange: '#EC8A61',
  red: '#DB6B75',
};

export const TEMPERATURE_COLOR_STOPS: ColorStop[] = [
  { value: -10, color: STOP_COLORS.white },
  { value: 0, color: STOP_COLORS.purpleRed },
  { value: 10, color: STOP_COLORS.purple },
  { value: 20, color: STOP_COLORS.bluePurple },
  { value: 30, color: STOP_COLORS.blue },
  { value: 40, color: STOP_COLORS.greenBlue },
  { value: 50, color: STOP_COLORS.green },
  { value: 60, color: STOP_COLORS.yellowGreen },
  { value: 70, color: STOP_COLORS.yellow },
  { value: 80, color: STOP_COLORS.orangeYellow },
  { value: 90, color: STOP_COLORS.orange },
  { value: 100, color: STOP_COLORS.redOrange },
  { value: 110, color: STOP_COLORS.red },
  { value: 120, color: STOP_COLORS.white },
];

export const WIND_SPEED_COLOR_STOPS: ColorStop[] = [
  { value: 0, color: STOP_COLORS.white },
  { value: 1, color: STOP_COLORS.blue },
  { value: 10, color: STOP_COLORS.greenBlue },
  { value: 20, color: STOP_COLORS.green },
  { value: 30, color: STOP_COLORS.yellowGreen },
  { value: 40, color: STOP_COLORS.yellow },
  { value: 50, color: STOP_COLORS.orangeYellow },
  { value: 60, color: STOP_COLORS.orange },
  { value: 70, color: STOP_COLORS.redOrange },
  { value: 80, color: STOP_COLORS.red },
  { value: 90, color: STOP_COLORS.purpleRed },
  { value: 100, color: STOP_COLORS.purple },
  { value: 110, color: STOP_COLORS.bluePurple },
  { value: 120, color: STOP_COLORS.white },
];

export const PRECIPITATION_COLOR_STOPS: ColorStop[] = [
  { value: 0.0, color: STOP_COLORS.white },
  { value: 0.1, color: STOP_COLORS.blue },
  { value: 0.25, color: STOP_COLORS.greenBlue },
  { value: 0.5, color: STOP_COLORS.green },
  { value: 1.0, color: STOP_COLORS.yellowGreen },
  { value: 2.0, color: STOP_COLORS.yellow },
  { value: 3.0, color: STOP_COLORS.orangeYellow },
  { value: 4.0, color: STOP_COLORS.orange },
  { value: 6.0, color: STOP_COLORS.redOrange },
  { value: 8.0, color: STOP_COLORS.red },
  { value: 10.0, color: STOP_COLORS.purpleRed },
  { value: 12.0, color: STOP_COLORS.purple },
  { value: 14.0, color: STOP_COLORS.bluePurple },
  { value: 16.0, color: STOP_COLORS.white },
];

export const RELATIVE_HUMIDITY_COLOR_STOPS: ColorStop[] = [
  { value: 0, color: STOP_COLORS.white },
  { value: 5, color: STOP_COLORS.purpleRed },
  { value: 10, color: STOP_COLORS.red },
  { value: 15, color: STOP_COLORS.redOrange },
  { value: 20, color: STOP_COLORS.orange },
  { value: 30, color: STOP_COLORS.orangeYellow },
  { value: 40, color: STOP_COLORS.yellow },
  { value: 50, color: STOP_COLORS.yellowGreen },
  { value: 60, color: STOP_COLORS.green },
  { value: 70, color: STOP_COLORS.greenBlue },
  { value: 80, color: STOP_COLORS.blue },
  { value: 90, color: STOP_COLORS.bluePurple },
  { value: 100, color: STOP_COLORS.purple },
];

export const SENSOR_TYPE_TO_COLOR_STOPS: Record<
  FocusedSensorType,
  ColorStop[]
> = {
  airTemp: TEMPERATURE_COLOR_STOPS,
  dewPointTemperature: TEMPERATURE_COLOR_STOPS,
  precipitation1Hr: PRECIPITATION_COLOR_STOPS,
  relativeHumidity: RELATIVE_HUMIDITY_COLOR_STOPS,
  windGust: WIND_SPEED_COLOR_STOPS,
  windSpeed: WIND_SPEED_COLOR_STOPS,
};
